import {
	Atom,
	ComputedAtom,
	Reaction,
	ReactiveInstance,
	ReactiveRemoteOptions,
} from "./reactive-primitive-types";

export const remoteAtomMap = new WeakMap<
	Atom | ComputedAtom<unknown>,
	WeakMap<ReactiveInstance, Atom>
>();

export const reactiveRemotes = new Set<ReactiveInstance>();
export const remoteOptionsMap = new WeakMap<
	ReactiveInstance,
	ReactiveRemoteOptions | null
>();

export const remoteReactionsMap = new WeakMap<
	ReactiveInstance,
	Set<Reaction>
>();
